import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./mfa.scss";
import { regular } from "@fortawesome/fontawesome-svg-core/import.macro";
import { useDispatch, useSelector } from "react-redux";
import { getMfaDevices, getMfaFlowId, setResendCodeDeviceId } from "features/mfaSlice";
import { useRedirect } from "hooks/useRedirect";
import { usePostMfaMutation } from "./mfaService";
import { useNavigate } from "react-router-dom";
import Overlay from "components/ui/loading-spinners/Overlay/Overlay";
import { clearCooldown } from "features/resendCooldownSlice";
import Footer from "components/footer/Footer";
import { DEFAULT_LANGUAGE } from "utilities/Constant";
import { getCurrentUserId, selectPreferredLanguage, setPreferredLanguage } from "features/authSlice";
import { useEffect } from "react";

const Mfa = () => {
  const MfaFlowId = useSelector(getMfaFlowId);
  const devices = useSelector(getMfaDevices);
  const userId = useSelector(getCurrentUserId);
  const preferredLanguage = useSelector(selectPreferredLanguage);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useRedirect(MfaFlowId == "", "/");

  useEffect(() => {
    if (!preferredLanguage) {
      dispatch(setPreferredLanguage(DEFAULT_LANGUAGE));
    }
  }, [dispatch, preferredLanguage]);

  const emailAuthDetails = devices.find(
    (obj) => obj.type.toLowerCase() == "email"
  );
  const smsAuthDetails = devices.find((obj) => obj.type.toLowerCase() == "sms");

  const [sendRequest, { data, isSuccess, isLoading }] = usePostMfaMutation();

  if (data && isSuccess) {
    dispatch(clearCooldown());
    navigate("/authcode", { replace: true });
  }

  const handleClick = (deviceId: string) => {
    dispatch(setResendCodeDeviceId(deviceId));
    return sendRequest({
      id: deviceId,
      flowId: MfaFlowId,
      userId: userId,
    });
  };

  if (isLoading) return <Overlay />;

  return (
    <>
      <div className="mfa-container">
        <p className="mfa-container__header">2-Step Verification</p>
        <div
          className="box-container"
          onClick={async () => await handleClick(smsAuthDetails?.id ?? "")}
          onKeyUp={async () => await handleClick(smsAuthDetails?.id ?? "")}
        >
          <FontAwesomeIcon
            icon={regular("mobile-retro")}
            className="icon-mobile"
          />
          <div className="desc">
            <p className="desc__header">Phone number verification</p>
            <p className="desc__message">Send code to <br /> number ending in {smsAuthDetails?.phone?.slice(-4)}</p>
          </div>
          <div className="arrow-right">
            <FontAwesomeIcon
              icon={regular("chevron-right")}
            />
          </div>
        </div>
        <div
          className="box-container"
          onClick={async () => await handleClick(emailAuthDetails?.id ?? "")}
          onKeyUp={async () => await handleClick(emailAuthDetails?.id ?? "")}
        >
          <FontAwesomeIcon
            icon={regular("envelope")}
            className="icon-envelope"
          />
          <div className="desc">
            <p className="desc__header">Email verification</p>
            <p className="desc__message">Send code to <br />{emailAuthDetails?.email}</p>
          </div>
          <div className="arrow-right">
            <FontAwesomeIcon
              icon={regular("chevron-right")}
            />
          </div>
        </div>
      </div>
      <div className="mfa__footer">
        <Footer />
      </div>
    </>
  );
};
export default Mfa;
